<script type="text/javascript">
	import ProductsFilter from "../ui/products/filter.svelte";
	import Product from "../ui/products/product.svelte";
	let filter; 
	
	
	let skip = 0;
	export let api;
	let products;
	
	if (typeof global === "undefined") {
		//products = Array(50).fill({loading: true});
		if (window.clientContext.filter) filter = window.clientContext.filter;
		console.log(window.clientContext.filter);
		api.getProducts(filter, e => {
			products = e;
		});
	}
	else{
		products = global.ssrContext.products;
	}


	function filterChange(){
		skip = 0;
		allScrolled = false;
		products = Array(50).fill({loading:true });
		window.api.getProducts(filter, e=>{products = e;});
	}

	let scrollLoading = false;
	let allScrolled = false;
	if (typeof global === 'undefined') {
		window.addEventListener('scroll', function (e) {
			let scrolled = document.documentElement.scrollTop + window.innerHeight;
			let toScroll = document.documentElement.scrollHeight;
			let loadHeight = 0;

			if (!allScrolled && !scrollLoading && (toScroll - scrolled) <= loadHeight) {
				scrollLoading = true;
				skip = skip + 50;

				let load = Array(50).fill({loading: true});
				products.push(...load);
				products = products;

				api.getProducts(filter, e => {
					let oldProducts = products;

					oldProducts.splice(-50);
					if (e.length === 0) allScrolled = true;
					else oldProducts.push(...e);

					products = oldProducts;
					scrollLoading = false;
				}, skip, 50);
			}
		});
	}
</script>
<ProductsFilter api={api} bind:filter on:change={filterChange} />

<ul class="products row">
	{#if products}
	{#each products as product}
		<li class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
			<Product {...product}/>
		</li>
	{/each}
	{/if}
</ul>

<style type="text/css">


	.products{
		list-style: none;
		display: flex;
		margin-left: -55px;
		margin-top: 25px;
		flex-wrap: wrap;
	}
	@media(min-width: 1800px){
		.products > li{

   			 width: 25% !important;
		}
	}

	.products > li{
		margin-bottom: 20px;
	}

</style>